import gql from 'graphql-tag'

export default gql`
	query listOrderedItems($id: ID!) {
		cashAssist {
			listOrderedItems(filter: {orderId: $id}) {
				id
				orderId
				product {
					id
					code
					name
				}
				amount
			}
		}
	}
`
